import Annotator from "./Annotator";
export { Annotator };
export default Annotator;